import React from "react";
import { useLocation } from "react-router-dom";
import Centered from "./Centered";
import Empty from "./Empty";
import MainLayout from "./MainLayout";

function LayoutIndex({ children, isAuthenticated }) {
  let location = useLocation();
  let { pathname } = { ...location };
  if (["/error-page"].includes(pathname)) {
    return <Centered>{children}</Centered>;
  } else if (
    [
      "/login",
      "/forgotpassword",
      "/register",
      "/techlogin",
      "/supportlogin",
      "/verify",
      "/resetpassword",
    ].includes(pathname)
  ) {
    return <Empty>{children}</Empty>;
  } else {
    if (isAuthenticated) {
      return <MainLayout>{children}</MainLayout>;
    } else {
      return <Empty>{children}</Empty>;
    }
  }
}

export default LayoutIndex;
